import React from "react";
import InvoiceSettings from "../../components/Profile/InvoiceSettings";

function Invoice() {
  return <div><InvoiceSettings/></div>;
}

export default Invoice;
